import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import eadReadAction from './eadReadStudentCompany.action.json'

const eadReadStudentCompanyDefinition = defineReadAutoAction(eadReadAction, 'alunoEmpresa')

export default eadReadStudentCompanyDefinition
